// Carry Roll ThemeToggle — compact header button that cycles light/dark/system.

import { Monitor, Moon, Sun } from 'lucide-react';
import { useTheme } from '../../lib/useTheme';
import type { Theme } from '../../store/settingsSlice';

const ORDER: Theme[] = ['system', 'light', 'dark'];

const ICONS = {
  system: Monitor,
  light: Sun,
  dark: Moon,
} as const;

export function ThemeToggle() {
  const { theme, setTheme } = useTheme();
  const Icon = ICONS[theme];
  const next = ORDER[(ORDER.indexOf(theme) + 1) % ORDER.length] as Theme;

  return (
    <button
      type="button"
      className="btn icon-btn"
      onClick={() => setTheme(next)}
      title={`Theme: ${theme} (click to cycle)`}
      aria-label={`Current theme is ${theme}. Click to switch to ${next}.`}
      data-testid="theme-toggle"
    >
      <Icon size={18} aria-hidden="true" />
    </button>
  );
}
